import { Box, Button, Drawer, TextField, Typography } from '@material-ui/core';
import { useState } from 'react';
import useScreenShotContext from '../../hooks/useScreenShotContext/useScreenShotContext';
import Snackbar from '../Snackbar/Snackbar';

export default function ScreenShotDrawer() {
  const { screenShotDrawerOpen, setScreenShotDrawerOpen, message, setMessage, screenShot } = useScreenShotContext();
  const [notifOpen, setNotifOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const updateScreenShot = async () => {
    const endpoint = `${process.env.REACT_APP_TOKEN_ENDPOINT}/work-orders/call/screen-shots`;

    setLoading(true);

    const res = await fetch(endpoint, {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('portal_token'),
      },
      body: JSON.stringify({
        note: message,
        screen_shot_id: screenShot?.id,
      }),
    });

    setLoading(false);

    if (res.status === 200) {
      setNotifOpen(true);
      setTimeout(() => setNotifOpen(false), 4000);
    }
  };

  return (
    <>
      <Snackbar
        open={notifOpen}
        headline="Note saved successfully"
        message=""
        variant="info"
        handleClose={() => setNotifOpen(false)}
      />
      <Drawer open={screenShotDrawerOpen} anchor="right" onClose={() => setScreenShotDrawerOpen(false)}>
        <Box width={450} maxWidth="90vw">
          <Box py={4} px={2}>
            <Box display="flex" alignItems="center" gridGap={12}>
              <Typography variant="h6">Ver captura de pantalla</Typography>
            </Box>

            <Box mt={4} display="flex" justifyContent="center">
              <img style={{ maxWidth: '100%', maxHeight: '400px' }} src={screenShot?.image} alt="screen shot" />
            </Box>

            <Box mt={4}>
              <TextField
                fullWidth
                label="Nota"
                multiline
                rows={10}
                variant="outlined"
                value={message}
                onChange={e => setMessage(e.target.value)}
              />
            </Box>

            <Box mt={2}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => updateScreenShot()}
                disabled={loading}
              >
                Guardar
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}
